import { render, staticRenderFns } from "./SupportText.vue?vue&type=template&id=fbf97922&scoped=true"
import script from "./SupportText.vue?vue&type=script&lang=js"
export * from "./SupportText.vue?vue&type=script&lang=js"
import style0 from "./SupportText.vue?vue&type=style&index=0&id=fbf97922&prod&lang=scss&scoped=true"
import style1 from "./SupportText.vue?vue&type=style&index=1&id=fbf97922&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf97922",
  null
  
)

export default component.exports